import { render, staticRenderFns } from "./ResponsiveImageStrapi.vue?vue&type=template&id=43adff74&scoped=true&"
import script from "./ResponsiveImageStrapi.vue?vue&type=script&lang=js&"
export * from "./ResponsiveImageStrapi.vue?vue&type=script&lang=js&"
import style0 from "./ResponsiveImageStrapi.vue?vue&type=style&index=0&id=43adff74&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43adff74",
  null
  
)

export default component.exports